import React from 'react'

import { FormattedMessage } from 'react-intl'

import TradePriceIcon from 'app/assets/icons/profile/trade-price-icon.svg'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import Tooltip from 'app/components/base/Tooltip'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface PersonalPriceProps {
  isTradePrice: boolean
  actualPriceWithCurrency: string
}

const PersonalPrice = ({
  actualPriceWithCurrency,
  isTradePrice
}: PersonalPriceProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: 'center'
      }}
    >
      <Text variant="h2">{actualPriceWithCurrency}</Text>

      {isTradePrice && (
        // @ts-ignore
        <Tooltip
          {...(!IS_NATIVE_APP && {
            PopperProps: {
              disablePortal: true,
              popperOptions: {
                positionFixed: true,
                modifiers: {
                  name: 'preventOverflow',
                  options: {
                    enabled: true,
                    boundariesElement: 'window'
                  }
                }
              }
            }
          })}
          isCloseButton
          content={
            <Text variant="subtitle1" color="common.white">
              <FormattedMessage defaultMessage="This seller offers trade pricing to business customers. Log into your business account." />
            </Text>
          }
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <TradePriceIcon width="30px" height="30px" viewBox="0 0 24 24" />
        </Tooltip>
      )}
    </Stack>
  )
}

export default PersonalPrice
